// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.helpers-module_iconContainer___s0RO4 {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 16px;
  max-height: 16px;
}
.helpers-module_iconContainer___s0RO4[data-disable-maxheight=true] {
  max-width: none;
  max-height: none;
}
.theme--light .helpers-module_iconContainer___s0RO4.helpers-module_linkOut___QUs6Z {
  color: #888888;
}
.theme--dark .helpers-module_iconContainer___s0RO4.helpers-module_linkOut___QUs6Z {
  color: #a3a3a3;
}
.helpers-module_iconContainer___s0RO4.helpers-module_linkOut___QUs6Z path {
  stroke: #969ba0;
}
.helpers-module_iconContainer___s0RO4.helpers-module_linkOut___QUs6Z[data-is-active=true] path {
  stroke: var(--textDetails);
}

.helpers-module_ellipsisDiv___IqBSL {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.helpers-module_center___Ln5wJ, .helpers-module_centerWithGap___Z45ul {
  display: flex;
  align-items: center;
  justify-content: center;
}

.helpers-module_centerWithGap___Z45ul {
  gap: 6px;
}

.helpers-module_growContainer___kGkKH {
  flex-grow: 1;
}

.helpers-module_legendText___ZJ_L7 {
  font-size: 1.1rem;
}
.theme--light .helpers-module_legendText___ZJ_L7 {
  color: #888888;
}
.theme--dark .helpers-module_legendText___ZJ_L7 {
  color: #a3a3a3;
}

.helpers-module_secondaryText___ACCfb {
  font-size: 1.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.theme--light .helpers-module_secondaryText___ACCfb {
  color: #888888;
}
.theme--dark .helpers-module_secondaryText___ACCfb {
  color: #a3a3a3;
}

.helpers-module_fullWidthHeightCenter___QMjtv {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
.theme--light .helpers-module_fullWidthHeightCenter___QMjtv {
  color: #888888;
  background-color: #ffffff;
}
.theme--dark .helpers-module_fullWidthHeightCenter___QMjtv {
  color: #a3a3a3;
  background-color: #1c1c1c;
}

.helpers-module_flexSmallGap___wj31Z {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.theme--light .helpers-module_rowWithSold___F7Fs7 td {
  background-color: #cfe1cb !important;
}
.theme--light .helpers-module_rowWithSold___F7Fs7 td div div {
  color: #212121;
}
.theme--light .helpers-module_rowWithSold___F7Fs7 > td:first-child,
.theme--light .helpers-module_rowWithSold___F7Fs7 > div:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  position: relative;
}
.theme--light .helpers-module_rowWithSold___F7Fs7 > td:first-child::before,
.theme--light .helpers-module_rowWithSold___F7Fs7 > div:first-child::before {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background-color: #4e9d3a;
}
.theme--dark .helpers-module_rowWithSold___F7Fs7 td {
  background-color: #4a5c46 !important;
}
.theme--dark .helpers-module_rowWithSold___F7Fs7 td div div {
  color: #f0f0f0;
}
.theme--dark .helpers-module_rowWithSold___F7Fs7 > td:first-child,
.theme--dark .helpers-module_rowWithSold___F7Fs7 > div:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  position: relative;
}
.theme--dark .helpers-module_rowWithSold___F7Fs7 > td:first-child::before,
.theme--dark .helpers-module_rowWithSold___F7Fs7 > div:first-child::before {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background-color: #4e9d3a;
}

.theme--light .helpers-module_rowWithOnHold___sQuRh td {
  background-color: #fff3c4 !important;
}
.theme--light .helpers-module_rowWithOnHold___sQuRh td div div {
  color: #212121;
}
.theme--light .helpers-module_rowWithOnHold___sQuRh > td:first-child,
.theme--light .helpers-module_rowWithOnHold___sQuRh > div:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  position: relative;
}
.theme--light .helpers-module_rowWithOnHold___sQuRh > td:first-child::before,
.theme--light .helpers-module_rowWithOnHold___sQuRh > div:first-child::before {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background-color: #e0a800;
}
.theme--dark .helpers-module_rowWithOnHold___sQuRh td {
  background-color: #5c5630 !important;
}
.theme--dark .helpers-module_rowWithOnHold___sQuRh td div div {
  color: #f0f0f0;
}
.theme--dark .helpers-module_rowWithOnHold___sQuRh > td:first-child,
.theme--dark .helpers-module_rowWithOnHold___sQuRh > div:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  position: relative;
}
.theme--dark .helpers-module_rowWithOnHold___sQuRh > td:first-child::before,
.theme--dark .helpers-module_rowWithOnHold___sQuRh > div:first-child::before {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background-color: #e0a800;
}

.theme--light .helpers-module_rowWithCancelled___w58dO td {
  background-color: rgba(192, 57, 43, 0.06) !important;
}
.theme--light .helpers-module_rowWithCancelled___w58dO > td:first-child,
.theme--light .helpers-module_rowWithCancelled___w58dO > div:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  position: relative;
}
.theme--light .helpers-module_rowWithCancelled___w58dO > td:first-child::before,
.theme--light .helpers-module_rowWithCancelled___w58dO > div:first-child::before {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background-color: #c0392b;
}
.theme--dark .helpers-module_rowWithCancelled___w58dO td {
  background-color: rgba(192, 57, 43, 0.06) !important;
}
.theme--dark .helpers-module_rowWithCancelled___w58dO > td:first-child,
.theme--dark .helpers-module_rowWithCancelled___w58dO > div:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  position: relative;
}
.theme--dark .helpers-module_rowWithCancelled___w58dO > td:first-child::before,
.theme--dark .helpers-module_rowWithCancelled___w58dO > div:first-child::before {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background-color: #c0392b;
}

.helpers-module_xIcon___AeOwL {
  color: #cccccc;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 200ms;
}
.helpers-module_xIcon___AeOwL:hover {
  color: #999999;
}

.helpers-module_itemRotation___Qd6Xp {
  transition: transform 200ms;
}
.helpers-module_itemRotation___Qd6Xp:hover {
  transform: rotate(45deg);
}

.helpers-module_seasonRowStyle___do4W4 {
  margin-top: 0.4rem;
  border-radius: 4px;
  display: block;
}
.theme--light .helpers-module_seasonRowStyle___do4W4 {
  border: 1px solid #dddddd;
}
.theme--dark .helpers-module_seasonRowStyle___do4W4 {
  border: 1px solid #2f2f2f;
}
.theme--light .helpers-module_seasonRowStyle___do4W4:hover {
  background-color: #ffffff;
}
.theme--dark .helpers-module_seasonRowStyle___do4W4:hover {
  background-color: #1c1c1c;
}

.helpers-module_seasonHeaderStyle___rZaWh {
  display: block;
}

.theme--light .helpers-module_textPrimary___YGXaD {
  color: #212121;
}
.theme--dark .helpers-module_textPrimary___YGXaD {
  color: #f0f0f0;
}

.helpers-module_isUserListing___DUnwn td {
  background-color: var(--legendYellow) !important;
  color: black;
}

.helpers-module_headlinerRightContent___QKFC5 {
  display: flex;
  gap: 0.8rem;
  padding: 2px;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
}
.theme--light .helpers-module_headlinerRightContent___QKFC5 {
  color: #212121;
}
.theme--dark .helpers-module_headlinerRightContent___QKFC5 {
  color: #f0f0f0;
}
.helpers-module_headlinerRightContent___QKFC5 > * {
  flex-shrink: 0;
}
.helpers-module_headlinerRightContent___QKFC5::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.helpers-module_grow___NDDiQ {
  flex-grow: 1;
}

.helpers-module_displayContents___fL7lj {
  display: contents;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/helpers.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAmBD;AAjBC;EACC,eAAA;EACA,gBAAA;AAmBF;AD0EE;ECxFC,cAAA;AAiBH;ADuEE;ECxFC,cAAA;AAoBH;AAjBE;EACC,eAAA;AAmBH;AAfG;EACC,0BAAA;AAiBJ;;AAXA;EACC,mBAAA;EACA,gBAAA;EACA,uBAAA;AAcD;;AAXA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AAcD;;AAXA;EAEC,QAAA;AAaD;;AAVA;EACC,YAAA;AAaD;;AAVA;EAKC,iBAAA;AASD;ADsCE;EClDA,cAAA;AAeF;ADmCE;EClDA,cAAA;AAkBF;;AAZA;EAKC,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAWD;ADyBE;EC1CA,cAAA;AAoBF;ADsBE;EC1CA,cAAA;AAuBF;;AAdA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAiBD;ADUE;ECxBA,cAAA;EACA,yBAAA;AAiBF;ADME;ECxBA,cAAA;EACA,yBAAA;AAqBF;;AAjBA;EACC,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAoBD;;AAfE;EACC,oCAAA;AAkBH;AAhBG;EACC,cAAA;AAkBJ;AAdE;;EAEC,2BAAA;EACA,8BAAA;EACA,kBAAA;AAgBH;AAdG;;EACC,2BAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAiBJ;AAxCE;EACC,oCAAA;AA0CH;AAxCG;EACC,cAAA;AA0CJ;AAtCE;;EAEC,2BAAA;EACA,8BAAA;EACA,kBAAA;AAwCH;AAtCG;;EACC,2BAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAyCJ;;AAjCE;EACC,oCAAA;AAoCH;AAlCG;EACC,cAAA;AAoCJ;AAhCE;;EAEC,2BAAA;EACA,8BAAA;EACA,kBAAA;AAkCH;AAhCG;;EACC,2BAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAmCJ;AA1DE;EACC,oCAAA;AA4DH;AA1DG;EACC,cAAA;AA4DJ;AAxDE;;EAEC,2BAAA;EACA,8BAAA;EACA,kBAAA;AA0DH;AAxDG;;EACC,2BAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AA2DJ;;AAnDE;EACC,oDAAA;AAsDH;AAnDE;;EAEC,2BAAA;EACA,8BAAA;EACA,kBAAA;AAqDH;AAnDG;;EACC,2BAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAsDJ;AAzEE;EACC,oDAAA;AA2EH;AAxEE;;EAEC,2BAAA;EACA,8BAAA;EACA,kBAAA;AA0EH;AAxEG;;EACC,2BAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AA2EJ;;AArEA;EACC,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAwED;AAtEC;EACC,cAAA;AAwEF;;AApEA;EACC,2BAAA;AAuED;AArEC;EACC,wBAAA;AAuEF;;AAnEA;EAKC,kBAAA;EACA,kBAAA;EACA,cAAA;AAkED;AD1KE;ECmGA,yBAAA;AA0EF;AD7KE;ECmGA,yBAAA;AA6EF;ADhLE;EC4GC,yBAAA;AAuEH;ADnLE;EC4GC,yBAAA;AA0EH;;AArEA;EACC,cAAA;AAwED;;AD1LE;ECuHA,cAAA;AAuEF;AD9LE;ECuHA,cAAA;AA0EF;;AAtEA;EACC,gDAAA;EACA,YAAA;AAyED;;AAtEA;EAKC,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAqED;AD/ME;ECkIA,cAAA;AAgFF;ADlNE;ECkIA,cAAA;AAmFF;AAzEC;EACC,cAAA;AA2EF;AAxEC;EACC,UAAA;EACA,WAAA;AA0EF;;AAtEA;EACC,YAAA;AAyED;;AAtEA;EACC,iBAAA;AAyED","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 16px;\n  max-height: 16px;\n}\n.iconContainer[data-disable-maxheight=true] {\n  max-width: none;\n  max-height: none;\n}\n:global(.theme--light) .iconContainer.linkOut {\n  color: #888888;\n}\n:global(.theme--dark) .iconContainer.linkOut {\n  color: #a3a3a3;\n}\n.iconContainer.linkOut path {\n  stroke: #969ba0;\n}\n.iconContainer.linkOut[data-is-active=true] path {\n  stroke: var(--textDetails);\n}\n\n.ellipsisDiv {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.center, .centerWithGap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.centerWithGap {\n  gap: 6px;\n}\n\n.growContainer {\n  flex-grow: 1;\n}\n\n.legendText {\n  font-size: 1.1rem;\n}\n:global(.theme--light) .legendText {\n  color: #888888;\n}\n:global(.theme--dark) .legendText {\n  color: #a3a3a3;\n}\n\n.secondaryText {\n  font-size: 1.1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n:global(.theme--light) .secondaryText {\n  color: #888888;\n}\n:global(.theme--dark) .secondaryText {\n  color: #a3a3a3;\n}\n\n.fullWidthHeightCenter {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n}\n:global(.theme--light) .fullWidthHeightCenter {\n  color: #888888;\n  background-color: #ffffff;\n}\n:global(.theme--dark) .fullWidthHeightCenter {\n  color: #a3a3a3;\n  background-color: #1c1c1c;\n}\n\n.flexSmallGap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n}\n\n:global(.theme--light) .rowWithSold td {\n  background-color: #cfe1cb !important;\n}\n:global(.theme--light) .rowWithSold td div div {\n  color: #212121;\n}\n:global(.theme--light) .rowWithSold > td:first-child,\n:global(.theme--light) .rowWithSold > div:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  position: relative;\n}\n:global(.theme--light) .rowWithSold > td:first-child::before,\n:global(.theme--light) .rowWithSold > div:first-child::before {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background-color: #4e9d3a;\n}\n:global(.theme--dark) .rowWithSold td {\n  background-color: #4a5c46 !important;\n}\n:global(.theme--dark) .rowWithSold td div div {\n  color: #f0f0f0;\n}\n:global(.theme--dark) .rowWithSold > td:first-child,\n:global(.theme--dark) .rowWithSold > div:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  position: relative;\n}\n:global(.theme--dark) .rowWithSold > td:first-child::before,\n:global(.theme--dark) .rowWithSold > div:first-child::before {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background-color: #4e9d3a;\n}\n\n:global(.theme--light) .rowWithOnHold td {\n  background-color: #fff3c4 !important;\n}\n:global(.theme--light) .rowWithOnHold td div div {\n  color: #212121;\n}\n:global(.theme--light) .rowWithOnHold > td:first-child,\n:global(.theme--light) .rowWithOnHold > div:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  position: relative;\n}\n:global(.theme--light) .rowWithOnHold > td:first-child::before,\n:global(.theme--light) .rowWithOnHold > div:first-child::before {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background-color: #e0a800;\n}\n:global(.theme--dark) .rowWithOnHold td {\n  background-color: #5c5630 !important;\n}\n:global(.theme--dark) .rowWithOnHold td div div {\n  color: #f0f0f0;\n}\n:global(.theme--dark) .rowWithOnHold > td:first-child,\n:global(.theme--dark) .rowWithOnHold > div:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  position: relative;\n}\n:global(.theme--dark) .rowWithOnHold > td:first-child::before,\n:global(.theme--dark) .rowWithOnHold > div:first-child::before {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background-color: #e0a800;\n}\n\n:global(.theme--light) .rowWithCancelled td {\n  background-color: rgba(192, 57, 43, 0.06) !important;\n}\n:global(.theme--light) .rowWithCancelled > td:first-child,\n:global(.theme--light) .rowWithCancelled > div:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  position: relative;\n}\n:global(.theme--light) .rowWithCancelled > td:first-child::before,\n:global(.theme--light) .rowWithCancelled > div:first-child::before {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background-color: #c0392b;\n}\n:global(.theme--dark) .rowWithCancelled td {\n  background-color: rgba(192, 57, 43, 0.06) !important;\n}\n:global(.theme--dark) .rowWithCancelled > td:first-child,\n:global(.theme--dark) .rowWithCancelled > div:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  position: relative;\n}\n:global(.theme--dark) .rowWithCancelled > td:first-child::before,\n:global(.theme--dark) .rowWithCancelled > div:first-child::before {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background-color: #c0392b;\n}\n\n.xIcon {\n  color: #cccccc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 200ms;\n}\n.xIcon:hover {\n  color: #999999;\n}\n\n.itemRotation {\n  transition: transform 200ms;\n}\n.itemRotation:hover {\n  transform: rotate(45deg);\n}\n\n.seasonRowStyle {\n  margin-top: 0.4rem;\n  border-radius: 4px;\n  display: block;\n}\n:global(.theme--light) .seasonRowStyle {\n  border: 1px solid #dddddd;\n}\n:global(.theme--dark) .seasonRowStyle {\n  border: 1px solid #2f2f2f;\n}\n:global(.theme--light) .seasonRowStyle:hover {\n  background-color: #ffffff;\n}\n:global(.theme--dark) .seasonRowStyle:hover {\n  background-color: #1c1c1c;\n}\n\n.seasonHeaderStyle {\n  display: block;\n}\n\n:global(.theme--light) .textPrimary {\n  color: #212121;\n}\n:global(.theme--dark) .textPrimary {\n  color: #f0f0f0;\n}\n\n.isUserListing td {\n  background-color: var(--legendYellow) !important;\n  color: black;\n}\n\n.headlinerRightContent {\n  display: flex;\n  gap: 0.8rem;\n  padding: 2px;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n:global(.theme--light) .headlinerRightContent {\n  color: #212121;\n}\n:global(.theme--dark) .headlinerRightContent {\n  color: #f0f0f0;\n}\n.headlinerRightContent > * {\n  flex-shrink: 0;\n}\n.headlinerRightContent::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n.grow {\n  flex-grow: 1;\n}\n\n.displayContents {\n  display: contents;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContainer": `helpers-module_iconContainer___s0RO4`,
	"linkOut": `helpers-module_linkOut___QUs6Z`,
	"ellipsisDiv": `helpers-module_ellipsisDiv___IqBSL`,
	"center": `helpers-module_center___Ln5wJ`,
	"centerWithGap": `helpers-module_centerWithGap___Z45ul`,
	"growContainer": `helpers-module_growContainer___kGkKH`,
	"legendText": `helpers-module_legendText___ZJ_L7`,
	"secondaryText": `helpers-module_secondaryText___ACCfb`,
	"fullWidthHeightCenter": `helpers-module_fullWidthHeightCenter___QMjtv`,
	"flexSmallGap": `helpers-module_flexSmallGap___wj31Z`,
	"rowWithSold": `helpers-module_rowWithSold___F7Fs7`,
	"rowWithOnHold": `helpers-module_rowWithOnHold___sQuRh`,
	"rowWithCancelled": `helpers-module_rowWithCancelled___w58dO`,
	"xIcon": `helpers-module_xIcon___AeOwL`,
	"itemRotation": `helpers-module_itemRotation___Qd6Xp`,
	"seasonRowStyle": `helpers-module_seasonRowStyle___do4W4`,
	"seasonHeaderStyle": `helpers-module_seasonHeaderStyle___rZaWh`,
	"textPrimary": `helpers-module_textPrimary___YGXaD`,
	"isUserListing": `helpers-module_isUserListing___DUnwn`,
	"headlinerRightContent": `helpers-module_headlinerRightContent___QKFC5`,
	"grow": `helpers-module_grow___NDDiQ`,
	"displayContents": `helpers-module_displayContents___fL7lj`
};
export default ___CSS_LOADER_EXPORT___;
